import { useTranslation } from "react-i18next";
import { DataEntryVehicleStepSectionProps, typedMemo } from "src/types";
import { FormRow, InputText } from "src/ui/widgets";

export const DataEntryVehicleStepContractor = typedMemo(
  ({
    formikFieldBaseName,
    formikVehicleValues,
    formikVehicleErrors,
    formikVehicleTouched,
    formik,
    validationSchema
  }: DataEntryVehicleStepSectionProps) => {
    const { t } = useTranslation();

    const { handleChange, handleBlur } = formik;

    return (
      <>
        <FormRow
          firstField={
            <InputText
              name={`${formikFieldBaseName}.contractor.name`}
              handleChange={handleChange}
              handleBlur={handleBlur}
              validationSchema={validationSchema}
              touched={formikVehicleTouched?.contractor?.name}
              value={formikVehicleValues?.contractor?.name}
              error={formikVehicleErrors?.contractor?.name}
              label={`${t("commons.name")}`}
              placeholder={t("commons.insert")}
            />
          }
          secondField={
            <InputText
              name={`${formikFieldBaseName}.contractor.surname`}
              handleChange={handleChange}
              handleBlur={handleBlur}
              validationSchema={validationSchema}
              touched={formikVehicleTouched?.contractor?.surname}
              value={formikVehicleValues?.contractor?.surname}
              error={formikVehicleErrors?.contractor?.surname}
              label={`${t("commons.surname")}`}
              placeholder={t("commons.insert")}
            />
          }
        />
        <FormRow
          firstField={
            <InputText
              name={`${formikFieldBaseName}.contractor.fiscalCodeOrVAT`}
              handleChange={handleChange}
              handleBlur={handleBlur}
              validationSchema={validationSchema}
              touched={formikVehicleTouched?.contractor?.fiscalCodeOrVAT}
              value={formikVehicleValues?.contractor?.fiscalCodeOrVAT}
              error={formikVehicleErrors?.contractor?.fiscalCodeOrVAT}
              label={`${t("commons.fiscal_code_vat_num")}`}
              placeholder={t("commons.insert")}
            />
          }
          secondField={
            <InputText
              name={`${formikFieldBaseName}.contractor.address`}
              handleChange={handleChange}
              handleBlur={handleBlur}
              validationSchema={validationSchema}
              touched={formikVehicleTouched?.contractor?.address}
              value={formikVehicleValues?.contractor?.address}
              error={formikVehicleErrors?.contractor?.address}
              label={`${t("commons.address_and_details")}`}
              placeholder={t("commons.insert")}
            />
          }
        />
      </>
    );
  }
);
